import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPlay = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.576 14.94a25.7 25.7 0 0 1-7.536 4.729c-2.433.959-4.471-.237-4.77-2.635-.364-3.535-.356-6.92 0-10.078.326-2.493 2.571-3.55 4.77-2.625 2.815 1.154 5.34 2.719 7.536 4.73 1.876 1.698 1.92 4.114 0 5.879"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
